export default "__VITE_ASSET__CqAzbusT__"